import { SpecialActionAccesses, SpecialActionNode } from '../../../models/roles';

export class NullObjectSpecialActions {
    static readonly specialActions = (() => {

        const node: SpecialActionNode = {
            canExecute: false,
            title: ''
        };

        const handler: ProxyHandler<SpecialActionAccesses> = {
            get: function (obj, prop) {
                return node;
            }
        };

        return new Proxy<SpecialActionAccesses>({} as any, handler);
    })();
}